module.exports = __webpack_public_path__ + "static/media/qrcode.81d595fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post05/qrcode.png
// module id = 115
// module chunks = 0